import { defineComponent } from 'vue';
export default defineComponent({
    name: 'Tabs',
    compatConfig: {
        MODE: 3,
    },
    props: {
        size: {
            type: String,
            default: 'small',
        },
        onActivateTab: Function,
        destroyTabContentWhenSwitching: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            tabs: [],
            activeTab: '0',
        };
    },
    computed: {
        tabMethods() {
            return {
                'is-active': this.isActive,
                'register-tab': this.registerTab,
                'destroy-tab-when-inactive': this.destroyTabContentWhenSwitching,
            };
        },
    },
    methods: {
        registerTab(label, id) {
            if (this.tabs.length === 0) {
                this.activeTab = id;
            }
            // eslint-disable-next-line fp/no-mutating-methods
            this.tabs.push({ label, id });
        },
        isActive(index) {
            return index === this.activeTab;
        },
        async activateTab(index) {
            if (index === this.activeTab) {
                return;
            }
            if (!this.$props.onActivateTab) {
                this.activeTab = index;
                return;
            }
            const cancelTab = await new Promise((resolve) => {
                const result = this.onActivateTab?.({
                    index: this.tabs.findIndex((tab) => tab.id === index),
                    currentIndex: this.tabs.findIndex((tab) => tab.id === this.activeTab),
                    cancelTabSwitch: () => resolve(true),
                });
                if (result?.then instanceof Function) {
                    result.then(() => resolve(false));
                }
                else {
                    resolve(false);
                }
            });
            if (!cancelTab) {
                this.activeTab = index;
            }
        },
    },
});
